var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserFriends = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.5 13a5.5 5.5 0 0 1 5.5 5.5.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5A5.5 5.5 0 0 1 9.5 13Zm0 1a4.5 4.5 0 0 0-4.473 4h8.946A4.5 4.5 0 0 0 9.5 14Zm7-2a3.5 3.5 0 0 1 3.5 3.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 1 1 0-1H19v-.5a2.5 2.5 0 0 0-3.882-2.084.5.5 0 1 1-.554-.832A3.485 3.485 0 0 1 16.5 12Zm-7-7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm7 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserFriends);
export default ForwardRef;